import {
  AppliedFilterSection_Value,
  FilterSection,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {useMemo} from 'react';
import {useSelectedFavouriteBrands} from '../PersonalizedFilters/utils/useSelectedFavouriteBrands';

export const DEFAULT_SORT = 'topseller';

export const useAppliedFiltersData = ({
  filters,
  activeFilters,
}: {
  filters: FilterSection[];
  activeFilters: Map<string, string[] | undefined>;
}) => {
  const selectedFavouriteBrands = useSelectedFavouriteBrands({
    filters,
    activeFilters,
  });

  return useMemo(
    () =>
      filters.reduce((partial, filter) => {
        if (filter.type?.$case === 'appliedFilter') {
          const appliedFiltersValues = filter.type?.appliedFilter?.values;

          const filteredSelectedFavouriteBrands = selectedFavouriteBrands
            .filter(brand => {
              const brandId =
                brand.value?.$case === 'attribute' && brand.value.attribute.id;

              return !appliedFiltersValues.some(
                filter =>
                  filter.value?.$case === 'attribute' &&
                  filter.value.attribute.id === brandId,
              );
            })
            .map(item => ({...item, isFavorite: true}));

          return [
            ...partial,
            ...appliedFiltersValues,
            ...filteredSelectedFavouriteBrands,
          ];
        }

        return partial;
      }, [] as AppliedFilterSection_Value[]),
    [filters, selectedFavouriteBrands],
  );
};
